import {
  getPathFromState,
  NavigatorScreenParams,
  ParamListBase,
  PartialState,
  NavigationState,
  LinkingOptions,
  InitialState,
} from '@react-navigation/native';

export function getPathFromParams(
  screen: keyof ReactNavigation.RootParamList,
  params?: ReactNavigation.RootParamList[keyof ReactNavigation.RootParamList],
  linkingConfig?: LinkingOptions<ParamListBase>['config'],
) {
  return getPathFromState(
    {
      routes: [
        {
          name: screen,
          params,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          state: getStateFromParams(params),
        },
      ],
    },
    linkingConfig,
  );
}

export function getStateFromParams<
  T extends NavigatorScreenParams<ParamListBase> | undefined,
>(params: T): PartialState<NavigationState> | undefined {
  if (!params?.screen) {
    return undefined;
  }

  return {
    routes: [
      {
        name: params.screen,
        params: params.params,
        state: params.screen
          ? getStateFromParams(params.params as T)
          : undefined,
      },
    ],
  };
}

export function getRouteNamesFromState(state: InitialState) {
  let current: InitialState | undefined = state;
  const routeNames: string[] = [];

  do {
    routeNames.push(current.routes[current.index ?? 0].name);
    current = current.routes[current.index ?? 0].state;
  } while (
    typeof current?.routes[current.index ?? 0].state !== 'undefined'
  );

  return routeNames;
}

export function getFocusedRouteFromState(state: InitialState) {
  let current: InitialState | undefined = state;

  while (
    typeof current?.routes[current.index ?? 0].state !== 'undefined'
  ) {
    current = current.routes[current.index ?? 0].state;
  }

  return current?.routes[current?.index ?? 0];
}
